import { useEffect, useState } from 'react';
import { getAuthProviders } from '@/services/authExtras';
import { isNative } from '@/lib/platform';

/**
 * The Google client ID when this environment offers Google sign-in, else null
 * (#2324). Null on native: Google blocks its sign-in inside app webviews, so
 * the app keeps password sign-in (native Google sign-in is a follow-up).
 */
export function useGoogleClientId(): string | null {
  const [clientId, setClientId] = useState<string | null>(null);
  useEffect(() => {
    if (isNative()) return;
    let cancelled = false;
    getAuthProviders()
      .then((p) => { if (!cancelled) setClientId(p.google?.client_id ?? null); })
      // No providers answer means no Google button; every other sign-in
      // option on the page is unaffected, so there is nothing to tell anyone.
      .catch(() => { /* button stays hidden */ });
    return () => { cancelled = true; };
  }, []);
  return clientId;
}
